<template>
  <div class="contentBox">
    <div class="container">
      <!---->
      <div class="article">
        <div class="text page-title">Yêu cầu hủy tài khoản game</div>
        <p class="strong">Đăng nhập tài khoản nền tảng đã liên kết với game</p>
        <div class="text">
          Người chơi thân mến, để đảm bảo an toàn cho tài khoản của bạn, vui
          lòng đăng nhập vào bất kỳ tài khoản nền tảng nào đã liên kết với tài
          khoản game mà bạn muốn hủy.
        </div>
        <div class="login-type-btn" @click="handleClick('account')">
          <img
            src="../../assets/img/deleteAccount/account_icon.png"
            alt=""
            class="type-icon"
          /><span class="type-title">Account</span>
        </div>
        <div class="login-type-btn" @click="handleClick('fb')">
          <img
            src="../../assets/img/deleteAccount/fb_icon.png"
            alt=""
            class="type-icon"
          /><span class="type-title">Facebook</span>
        </div>
        <div class="login-type-btn">
          <div id="g_id_signin2"></div>
          <img
            src="../../assets/img/deleteAccount/google_icon.png"
            alt=""
            class="type-icon"
          /><span class="type-title">Google Play</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      fb_appid: "1114786559496051", //fb登录id
      client_id:
        "698305642286-d168sf42qjnc1rv5piu9c6nhm9tkdvag.apps.googleusercontent.com", //谷歌登录id
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getFb();
  },
  mounted() {
    this.init();
  },
  methods: {
    getData() {
      let game_id = this.$route.query.g;
      let params = {
        g: game_id,
      };
      this.$http.get("/login/index", { params }).then((res) => {
        if (res.data.code == 200) {
          this.fb_appid = res.data.data.fb_appid;
          if (res.data.data.client_id) {
            this.client_id = res.data.data.client_id;
            this.init();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getFb() {
      // fbid
      const fb_appid = "1114786559496051";
      // 加载 facebook SDK
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");

      window.fbAsyncInit = function () {
        this.fbIsOK = true;
        FB.init({
          appId: fb_appid,
          cookie: true,
          xfbml: true,
          version: "v2.8",
        });
      };
    },
    handleClick(name) {
      let game_id = this.$route.query.g;
      switch (name) {
        case "account":
          this.$router.push({
            path: "/main/deletion/login",
            query: {
              g: game_id,
            },
          });
          break;
        case "fb":
          this.loginWithFacebook();
          break;
        case "google":
          // this.loginWithGoogle();
          break;
        default:
          break;
      }
    },
    loginWithFacebook() {
      let _this = this;
      FB.login(
        function (response) {
          if (response.status === "connected") {
            FB.api(
              "/me?fields=id,name,token_for_business",
              function (response) {
                _this.Login(1, response.token_for_business);
              }
            );
          } else {
          }
        },
        { scope: "public_profile,email" }
      );
    },

    Login(num, access_token) {
      let params = {
        username: access_token,
        login_type: num == 1 ? 3 : 4,
      };
      this.$http.post("/api/login", params).then((res) => {
        if (res.code === 200) {
          this.handleCheck(res.data.token);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //谷歌登录
    init() {
      this.gload();
    },
    gload() {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          // 主要就是填写client_id
          client_id: this.client_id,
          callback: this.handleCredentialResponse,
        });
        console.log("Google API initialized");
        window.google.accounts.id.renderButton(
          document.getElementById("g_id_signin2"),
          {
            type: "standard",
            theme: "filled_blue",
            size: "large",
            text: "continue_with",
            shape: "pill",
            logo_alignment: "left",
            width: 300,
          }
        );
      } else {
        console.error("Google API not loaded");
      }
    },
    decodeJwtResponse(token) {
      const strings = token.split(".");
      return JSON.parse(
        decodeURIComponent(
          escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/")))
        )
      );
    },

    handleCredentialResponse(response) {
      if (response) {
        const responsePayload = this.decodeJwtResponse(response.credential);
        this.Login(2, responsePayload.email);
      }
    },
    handleCheck(token) {
      this.$router.push({
        path: "/main/deletion/isDeleteAccount",
        query: {
          t: token,
        },
      });
    },
  },
};
</script>

<style>
@import "./css/index.css";
.S9gUrf-YoZ4jf {
  opacity: 0;
}
#g_id_signin2 {
  position: absolute;
  width: auto;
}
</style>
